export default __webpack_public_path__ + "static/media/pitcher.63cee8ac.png";